import "./DetailStyle.css";

const Detail = () => {
    return (
        <div className="detail-container">
            <div className="detail-heading">
                <h1>ABOUT ME</h1>
            </div>
            <div className="detail">
                <div className="self">
                    <h2>My Self</h2>
                    <p>I am an Electronics and Communication Engineer, passionate programmer and currently exploring the web development world with full of joy and dedication. Currently I am a student with average CGPA 8.5 from Arya College of Engineering & IT(Jaipur).
                    I love to play cricket in my spare time and I am very fond of listening music, exploring new technology, reading novels. web development projet and coding is something on which i want to dedicate my carrer.
                    </p>
                </div>
                <div className="edu">
                    <h2>My Education</h2>
                    <p>I have done my Schooling from my Home Town Muzaffarpur, Bihar, India. I did my Senior Secondary Education from Holy Mission Senior Secondary School with 65% And Secondary Education from the Holy Mission Senior Secondary School with 9.4 CGPA. Currently I am in my final year of my B.Tech and I am seeking for a responsible position in an Organization.</p>
                </div>
            </div>
        </div>
    )
}
export default Detail;